// File Location: src/pages/auth/Unauthorized.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft, Home } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleLogout = async () => {
    await logout();
    // The logout function in AuthContext will handle the redirect to /login
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-8 border border-teal-100">
          {/* Icon */}
          <div className="bg-red-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Shield className="h-10 w-10 text-red-500" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Access Denied
          </h1>

          {/* Message */}
          <p className="text-gray-600 mb-8">
            You don't have permission to access this page. Please contact your administrator 
            if you believe this is an error.
          </p>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleGoBack}
              className="w-full flex items-center justify-center space-x-2 py-3 px-4 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 transition-all"
            >
              <ArrowLeft className="h-5 w-5" />
              <span>Go Back</span>
            </button>

            <button
              onClick={handleGoHome}
              className="w-full flex items-center justify-center space-x-2 py-3 px-4 border-2 border-teal-200 text-teal-600 font-medium rounded-lg hover:bg-teal-50 transition-all"
            >
              <Home className="h-5 w-5" />
              <span>Go Home</span>
            </button>

            <button
              onClick={handleLogout}
              className="w-full py-3 px-4 text-gray-600 font-medium rounded-lg hover:bg-gray-100 transition-all"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;